import { preview } from '@/components/form/preview'
import { useTexts } from './useTexts'

type Props = {
  integrationData: uui.domain.client.rm.ShopifyIntegrationData
}

export function Shopify(props: Props) {
  const {
    integrationData: { shopifyName },
  } = props

  const texts = useTexts()

  return (
    <preview.Section spacing={1}>
      <preview.SectionTitle>{texts.title}</preview.SectionTitle>
      <preview.Field label={texts.orderName}>
        <preview.Value>{shopifyName}</preview.Value>
      </preview.Field>
    </preview.Section>
  )
}
